/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
} from "@chakra-ui/react";
import { Link, useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import { useGetVehicleDetails } from "../../services/vehicles";
import FormInput from "../../components/forms/form-Input";
import NumericInput from "../../components/forms/react-hook-numeric-input";
import { dateFormat } from "../../utils/constants";
import { DEFAULT_VEHICLE } from "./constants";

export default function VehicleDetails() {
  const [vehicle, setVehicle] = useState({
    ...DEFAULT_VEHICLE,
  });
  const params = useParams();
  const {
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({});
  const generalFieldProps = { control, errors };

  const {
    mutate: getVehicle,
    data: vehicleRes,
    isPending: gettingVehicle,
    reset: resetVehicle,
  } = useGetVehicleDetails();

  useEffect(() => {
    if (vehicleRes) {
      const _data = {
        ...vehicleRes.data,
        registrationExpiry: moment(vehicleRes.data?.registrationExpiry).format(dateFormat),
        insuranceExpiry: moment(vehicleRes.data?.insuranceExpiry).format(dateFormat),
        armouringDate: moment(vehicleRes.data?.armouringDate).format(dateFormat),
        purchaseDate: moment(vehicleRes.data?.purchaseDate).format(dateFormat),
        lastFitnessDate: moment(vehicleRes.data?.lastFitnessDate).format(dateFormat),
        fitnessDueDate: moment(vehicleRes.data?.fitnessDueDate).format(dateFormat),
      };

      setVehicle(_data);
      reset({ ..._data });
      resetVehicle();
    }
  }, [vehicleRes]);

  useEffect(() => {
    if (params.vehicleId) {
      getVehicle(params.vehicleId);
    }
  }, []);

  return (
    <>
      {gettingVehicle ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Vehicles", link: Paths.vehiclesList },
            { text: "Vehicle Details", isCurrentPage: true },
          ]}
        />

        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "16px",
                  padding: "0px 0px 20px 0",
                }}
              >
                <Heading>{watch("registrationNo")}</Heading>
                <Button
                  as={Link}
                  to={`${Paths.editVehicle}/${params.vehicleId || watch("id")}`}
                >
                  Edit Vehicle
                </Button>
              </div>
              <div className="add-location-form">
                <form>
                  <FormInput
                    {...generalFieldProps}
                    name="cashCenter"
                    label="Cash Center"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    name="officeName"
                    label="Office"
                    readOnly
                  />

                  <FormInput
                    {...generalFieldProps}
                    label="Fleet No"
                    name="fleetNo"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Registration No"
                    name="registrationNo"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Make"
                    name="make"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Model"
                    name="model"
                    readOnly
                  />
                  <NumericInput
                    {...generalFieldProps}
                    label="Manufacturing Year"
                    name="manufacturingYear"
                    inputProps={{
                      format: "#",
                      className: "hide-spinners",
                      readOnly: true,
                    }}
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Van Type"
                    name="vanType"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Engine No"
                    name="engineNo"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Chassis No"
                    name="chassisNo"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Color"
                    name="color"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="City"
                    name="city"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Purchase Date"
                    name="purchaseDate"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Registration Type"
                    name="registrationType"
                    readOnly
                  />

                  <NumericInput
                    {...generalFieldProps}
                    label="Registration Year"
                    name="registrationYear"
                    inputProps={{ format: "#", className: "hide-spinners" }}
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Registration Expiry"
                    name="registrationExpiry"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Insurer"
                    name="insurer"
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Insurance Expiry"
                    name="insuranceExpiry"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Armoured By"
                    name="armouredBy"
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Armouring Date"
                    name="armouringDate"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Last Fitness Date"
                    name="lastFitnessDate"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    disabled
                    label="Fitness Due Date"
                    name="fitnessDueDate"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Fitness Interval"
                    name="fitnessInterval"
                    readOnly
                  />

                  <FormInput
                    {...generalFieldProps}
                    label="Cash Limit"
                    name="cashLimit"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Status"
                    name="status"
                    readOnly
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Issued To"
                    name="issuedTo"
                    readOnly
                  />
                  <FormControl>
                    <FormLabel style={{ visibility: "hidden" }}>
                      Fuel Tag
                    </FormLabel>
                    <Controller
                      control={generalFieldProps.control}
                      name="fuelTag"
                      render={({ field }) => {
                        return (
                          <Checkbox isChecked={field.value}>
                            <FormLabel style={{ margin: 0 }}>
                              Fuel Tag
                            </FormLabel>
                          </Checkbox>
                        );
                      }}
                    />
                  </FormControl>
                  <Heading
                    style={{
                      width: "100%",
                      fontSize: "14px",
                      borderTop: `1px solid var(--primary-light)`,
                      padding: "10px 0px",
                      margin: 0,
                    }}
                  >
                    Installed Locks
                  </Heading>

                  <Grid data={watch("installedLocks")}>
                    <GridColumn title="Lock Type" field="lockType" />
                    <GridColumn title="Vender" field="vender" />
                    <GridColumn title="Lock Serial No" field="lockSerilNo" />
                  </Grid>
                  {/* <Heading
                    style={{
                      width: "100%",
                      fontSize: "14px",
                      borderTop: `1px solid var(--primary-light)`,
                      padding: "10px 0px",
                      margin: 0,
                    }}
                  >
                    Pictures
                  </Heading>
                  <FormControl>
                    <FormLabel>Upload Picture</FormLabel>
                    <input
                      type={"file"}
                      accept="image/*"
                      onChange={(e) => {
                        console.log("E", e.target.value);
                      }}
                    />
                  </FormControl> */}
                </form>
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
